<!--
 * @Author: your name
 * @Date: 2022-05-30 15
-->
<!-- 维修视频 -->
<template>
  <div class="travel-service">
    <div class="content">
      <p>建设中，敬请期待......</p>
    </div>
  </div>
</template>
<script>
import SecondTitle from '@/components/SecondTitle'
import examineMore from '@/components/examineMore'
export default {
  components:{
    SecondTitle,
    examineMore,
  },
  data(){
    return{
    }
  },
  methods:{
    
  }
}
</script>
<style lang="scss">
@import "./travel-service.scss";
</style>


// WEBPACK FOOTER //
// src/views/serve/travel-service/travel-service.vue